/** HTML escaping and the tiny inline syntax documents use: `code` and **bold**. */

export const esc = (s: string) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");

/** Escape first, then apply inline marks, so no input can produce markup. */
export function inline(s: string): string {
  return esc(s)
    // Paths break after a slash rather than mid-name when a table column is narrow.
    .replace(/`([^`]+)`/g, (_, c: string) => `<code>${c.replace(/\//g, "/<wbr>")}</code>`)
    .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
}

/** Strip inline marks for plain-text contexts (search index, CSV). */
export const plain = (s: string) => s.replace(/`([^`]+)`/g, "$1").replace(/\*\*([^*]+)\*\*/g, "$1");

/** JSON safe to embed inside a <script> element. */
export const scriptJson = (v: unknown) =>
  JSON.stringify(v)
    .replace(/</g, "\\u003c")
    .replace(new RegExp("\\u2028", "g"), "\\u2028")
    .replace(new RegExp("\\u2029", "g"), "\\u2029");

/** A section id safe for use as an HTML id and file name. */
export const slug = (s: string) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 60) || "section";
